import api from '@/api'

export default {

  getPlayerTalentSendListSystem (params) {
    return api({
      url: '/playerTalentSend/talentSendListSystem',
      method: 'GET',
      params
    })
  },

  getPlayerTalentSendListYouth (params) {
    return api({
      url: '/playerTalentSend/talentSendListYouth',
      method: 'GET',
      params
    })
  },
  getPlayerTalentSendListOrgan (params) {
    return api({
      url: '/playerTalentSend/talentSendListOrgan',
      method: 'GET',
      params
    })
  },
  deleteTalentSend(uuid) {
    return api({
      url: `/playerTalentSend/talentSendRemove/${uuid}`,
      method: 'POST'
    })
  },
  talentSendPlayerVerify(id_number, id_name) {
    return api({
      url:`/playerTalentSend/talentSendPlayerVerify/${id_number}/${id_name}`,
      method: 'GET'
    })
  },
  // 添加
  addTalentSend (data) {
    return api({
      url: '/playerTalentSend/talentSendAdd',
      method: 'POST',
      data
    })
  },
  // 编辑
  editTalentSend (data) {
    return api({
      url: '/playerTalentSend/talentSendEdit',
      method: 'POST',
      data
    })
  },
  // 审核
  talentSendAudit (data) {
    return api({
      url: '/playerTalentSend/talentSendAudit',
      method: 'POST',
      data
    })
  },
  // 审核记录
  talentSendAuditLogs (uuid) {
    return api({
      url: `/playerTalentSend/talentSendAuditLogs/${uuid}`,
      method: 'GET',
    })
  },
  getTalentSendInfo (uuid) {
    return api({
      url: `/playerTalentSend/talentSendInfo/${uuid}`,
      method: 'GET'
    })
  },
  getTalentSendExport (params) {
    return api({
      url: '/playerTalentSend/talentSendExport',
      method: 'GET',
      params
    })
  },
  getTalentSendCount() {
    return api({
      url: '/playerTalentSend/talentSendCount',
      method: 'GET'
    })
  },
}
